"use strict";
function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/isObject.js
// module id = 27
// module chunks = 0 1